import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import { FormGroup, Label } from '../formInputsV2/styles/common';
import { reactSelectStyles } from '../formInputsV2/reactSelectStyles';

function FormReactSelectProfessions({
  label, options, values, error, valid, onChange,
}) {
  const [prepOptions, setPrepOptions] = useState([]);

  const handleChange = (value) => {
    if (value.profession !== undefined || value.profession !== '') {
      const prof = options.find((opt) => opt.id == value.profession);
      if (prof !== undefined) {
        onChange({
          profession: prof.id,
        });
      }
    }

    if (value.profession === null || value.profession === '' || value.profession === undefined) {
      onChange({
        profession: '',
      });
    }
  };

  useEffect(() => {
    setPrepOptions(options.map((i) => ({ value: i.id, label: i.name })));
  }, [options]);

  return (
    <FormGroup>
      <Label>{label}</Label>
      <ReactSelect
        options={prepOptions}
        defaultOptions
        isSearchable
        placeholder=""
        value={options.filter((opt) => opt.id == values.profession).map((o) => ({ value: o.id, label: o.name }))[0]}
        onChange={(val) => {
          handleChange({
            profession: val === null || val === undefined ? '' : val.value,
          });
        }}
        loadingMessage={() => 'Caricando professioni...'}
        clearValue
        isClearable
        noOptionsMessage={() => 'Professioni non trovati!'}
        styles={reactSelectStyles({ error, valid })}
      />
      <div className="invalid-feedback">{error}</div>
    </FormGroup>
  );
}

export default FormReactSelectProfessions;
